import { Injectable } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

/**
 * Global fallback for missing translation keys.
 *
 * Document type display names are built via reverse enum lookup
 * (`'DOCUMENT_TYPE.' + enumDocumentType[doc.type]`). When the backend sends a document type
 * that is not yet mapped on the frontend, the lookup yields `undefined` and the key becomes
 * `DOCUMENT_TYPE.undefined`. Instead of rendering that raw key, fall back to a neutral
 * "Document" label. All other missing keys keep ngx-translate's default behavior (return the key).
 */
@Injectable()
export class AppMissingTranslationHandler implements MissingTranslationHandler {
  public handle(params: MissingTranslationHandlerParams): string {
    if (params.key === 'DOCUMENT_TYPE.undefined') {
      return params.translateService.instant('DOCUMENT_TYPE.OTHER_DOCUMENT');
    }

    return params.key;
  }
}
